import React, { useContext, useEffect, useState } from "react";
import { Colorcontext } from "../../Component/Colorcontext/ColorContext";
import searchicon from "../../Images/searchicon.png";
import searchresilutfilter from "../../Images/searchresilutfilter.png";
import { useNavigate, useLocation } from "react-router-dom";
import HttpClient from "../../utils/HttpClient";
import close from "../../Images/close.png";
import { useDispatch, useSelector } from "react-redux";
import { SetDisplayUserData } from "../../Redux/Slice/PostSlice";
import cameralogo from "../../../src/Images/cameralogo.png";
import moment from "moment/moment";
import "./Style.css"
import AdvancedSearchBox from "../../Modal/AdvancedSearchBox";
import NoRecordFoundMessage from "../OwnContactlist/NoRecordFound";
import BusinessOverview from "./BusinessOverview";
import LoadMoreButton from "./LoadMoreButton";
import CompanyListSkeleton from "./skeletons/CompanyListSkeleton";
import RelatedBusinessList from "./components/RelatedBusinessList";

const Blmemberlist = () => {
  const colordata = useContext(Colorcontext);
  const dispatch = useDispatch();
  const [ownpagesearchkeay, setownpagesearchkeay] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [company, setCompany] = useState([]);
  const { data, searchText } = location.state;
  const [searchedData, setSearchedData] = useState(data ?? []);
  const [relatedSearchedData, setRelatedSearchedData] = useState(location.state?.relatedResults?.length ? location.state?.relatedResults : []);
  const [text, setText] = useState(searchText ?? "");
  const [singleData, setSingleData] = useState();
  const [sponsorAdImage, setSponsorAdImage] = useState({})
  const [isMobile, setIsMobile] = useState(false);
  const [currentPage, setCurrentPage] = useState(data?.length ? location.state?.pagination?.page : 0);
  const [totalPages, setTotalPages] = useState(data?.length ? location.state?.pagination?.total : 0);
  const [searchCountry, setSearchCountry] = useState(location.state?.searchCountry ?? "");
  const [searchRegion, setSearchRegion] = useState(location.state?.searchRegion ?? "");
  const [searchIP, setSearchIP] = useState(location.state?.searchIp ?? "");
  const advancedSearchInit = {
    product: "",
    productCat: "",
    location: "",
    state: "",
    country: "",
    searchCountry: "",
    businessStatus: "",
  }
  const [filterKey, setFilterKey] = useState(advancedSearchInit);
  const [showLoader, setShowLoader] = useState(false);
  const [hasMore, setHasMore] = useState(data?.length ? location.state?.pagination?.hasMore : false);
  const [height, setHeight] = useState(10000);

  useEffect(() => {
    filterKey.searchCountry = searchCountry;
    filterKey.searchRegion = searchRegion;
    filterKey.searchIP = searchIP;
    setFilterKey({ ...filterKey });

    colordata.setcolor(true);
    return () => {
      colordata.setcolor(false);
    };
  }, [searchCountry, searchRegion]);

  const getCompanyName = (_id) => {
    const companyName = company.find((company) => company._id === _id);
    return companyName ? companyName.type : "";
  };

  const getCompany = async () => {
    const response = await HttpClient.requestData("companyType", "GET", "");
    if (response.status) {
      setCompany(response.data);
    } else {
      console.log("Error while fetching company data");
    }
  };

  const getSponsorAd = async () => {
    const response = await HttpClient.requestData("all-sponserAd", "GET", "");
    if (response?.status) {
      setSponsorAdImage(response.data[0] || {});
    } else {
      console.log("Error while fetching company data");
    }
  };

  const ownpagesearchkeyclcik = () => {
    setownpagesearchkeay(!ownpagesearchkeay);
  };

  const handleSingleData = (item) => {
    setSingleData(item)
    dispatch(SetDisplayUserData([item]))
  }

  const handleMobilePageView = (e, item) => {
    e.preventDefault()
    setSingleData(item)
    dispatch(SetDisplayUserData([item]))
    const slug = item?.companySlug || item?.companyName?.toLowerCase().replace(/\s+/g, "_");
    navigate(`/businesspage/${slug}`)
  }

  const handleMobileProfileView = (e, item) => {
    e.preventDefault()
    setSingleData(item)
    dispatch(SetDisplayUserData([item]))
    navigate(`/profile/${item?.userName?.trim()}`)
  }

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    getCompany()
    getSponsorAd()
  }, []);

  const handleKeyDown = (event) => {
    setText(event.target.value);
    if (event.key === "Enter") {
      let data = {
        ...filterKey,
        searchName: text,
        page: 1,
        limit: 20
      };
      search(data, true);
    }
  };

  // let isFetching = false;
  // useEffect(() => {
  //   const handleScroll = () => {
  //     if (
  //       window.innerHeight + window.scrollY >= document.body.offsetHeight - 100 &&
  //       currentPage < totalPages &&
  //       !isFetching
  //     ) {
  //       isFetching = true;
  //       let data = {
  //         ...filterKey,
  //         searchName: text,
  //         page: currentPage + 1,
  //         limit: 20
  //       };
  //       search(data).finally(() => {
  //         isFetching = false;
  //       });
  //     }
  //   };

  //   window.addEventListener("scroll", handleScroll);
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, [currentPage, totalPages]);

  const search = async (data, resetResult = false) => {
    setShowLoader(true);
    const response = await HttpClient.requestData("search-business", "POST", data);
    if (response?.status) {
      setRelatedSearchedData(response?.relatedResults);
      if (resetResult) {
        setSearchedData(response?.data);
      } else {
        setSearchedData((prevData) => [...prevData, ...response?.data]);
      }
      setTotalPages(response?.pagination?.total);
      setCurrentPage(response?.pagination?.page);
      setHasMore(response?.pagination?.hasMore);
    } else {
      console.log("Error while fetching the data ");
    }
    setShowLoader(false);
  };

  const searchName = async () => {
    let data = {
      ...filterKey,
      searchName: text,
      page: currentPage,
      limit: 20
    };
    search(data, true);
  };

  const handleSearchResult = (response) => {
    setSearchedData(response?.data);
    setRelatedSearchedData(response?.relatedResults);
    setCurrentPage(response?.pagination?.page);
    setTotalPages(response?.pagination?.total);
    setHasMore(response?.pagination?.hasMore);
  }

  const loadMore = () => {
    setHeight(prev => prev + 1500);
    let data = {
      ...filterKey,
      searchName: text,
      page: currentPage + 1,
      limit: 20
    };
    search(data, false);
  }

  const handleSelect = (item) => {
    handleSingleData(item);
  }

  const handleGetCompanyName = (item) => {
    getCompanyName(item);
  }

  const handleMobPageVw = (e, item) => {
    handleMobilePageView(e, item)
  }

  const handleMobProfileVw = (e, item) => {
    handleMobileProfileView(e, item)
  }

  return (
    <>
      <section className="ownseacrhresultpagemain">
        <div className="cust_container">
          <div className="searchhresultandfilterdivflx">
            <div className="searfchresultleftdiv">
              <input
                type="text"
                value={text}
                onChange={(e) => setText(e.target.value)}
                onKeyDown={(event) => handleKeyDown(event)}
                className="searfchresultleftdivmain"
                placeholder="Enter your text"
                style={{ paddingRight: "70px" }}
              />
              {text && (
                <div
                  className="searchiconimgnew"
                  style={{
                    position: "absolute",
                    top: "25%",
                    right: "7%",
                    cursor: "pointer",
                    top: "10px",
                    right: "45px",
                  }}
                  onClick={() => setText("")}
                >
                  <img
                    style={{
                      height: "15px",
                      width: "15px",
                    }}
                    src={close}
                    alt="closing button"
                  />
                </div>
              )}
              <div
                style={{
                  top: "10px",
                }}
                className="sectgresulticon"
                onClick={searchName}
              >
                <img src={searchicon} alt="..." />
              </div>
            </div>

            <div className="searchfilterdiv">
              <div
                className="searchfilterdivmain"
                onClick={ownpagesearchkeyclcik}
              >
                <div className="sercghghfilyerimg">
                  <img src={searchresilutfilter} alt="..." />
                </div>
              </div>
            </div>
          </div>

          <div className="ownseacrgresultpagedivbg">
            <div className="ownseacrgresultpagedivflx" id="navbar-example3" style={{
              height: `${height}px`
            }}>

              {
                isMobile &&
                <div style={{ marginBottom: "1em" }}>
                  <p className="prPremiumofiletxtp">Sponsor Ad</p>
                  {
                    sponsorAdImage && (moment(sponsorAdImage?.expiryDate, "YYYY-MM-DD").isAfter(moment().startOf("day")) || moment(sponsorAdImage?.expiryDate, "YYYY-MM-DD").isSame(moment().startOf("day"))) ?
                      <div>
                        <a href={sponsorAdImage?.adLinkUrl} target="_blank">
                          <img src={sponsorAdImage?.adImage}
                            style={{
                              maxWidth: "100%"
                            }}
                          />
                        </a>
                      </div> :
                      <div className="boxosimaggedisahdowdiv">
                        <p className="tsttsggsiijxbhnsimag">300x250</p>
                      </div>
                  }
                </div>
              }

              <div className="ownseacrgresultpageleft">
                <p className="avoiaresrrstrtxppp">
                  About {totalPages} results
                </p>
                {searchedData.length === 0 ? (
                  <>
                    <NoRecordFoundMessage message="No results found — but we’re always growing our network!" />
                    <RelatedBusinessList isMobile={isMobile} searchData={relatedSearchedData} handleSelect={handleSelect} handleGetCompanyName={handleGetCompanyName} handleMobPageVw={handleMobPageVw} handleMobProfileVw={handleMobProfileVw} />
                  </>
                ) : (
                  <>
                    {showLoader ? (<CompanyListSkeleton />) : (
                      <div>

                        {searchedData?.map((item, index) => (
                          <div
                            className="serchresutllogodetaildivflx"
                            key={index}
                            onClick={() => handleSingleData(item)}
                          >

                            <div className="serachresultlogoidiv">
                              <img src={item?.businessProfilePic || cameralogo} alt="..." />
                            </div>
                            <div className="serachresultdetailsdiv">
                              <h4 className="serctedheadrparatxt">
                                {item?.companyName} - {getCompanyName(item?.companyTypeID)}
                              </h4>

                              <div style={{ display: "flex", flexWrap: "wrap" }}>
                                {item?.businessProductCat?.slice(0, 3)?.map((it, idx) => (
                                  <p
                                    key={idx}
                                    className="diisjadfebnclkmdgragjksopjkl"
                                    style={{ marginLeft: "2px", fontWeight: "bold" }}
                                  >
                                    {it}
                                    {/* {item?.businessProductCat.length > idx + 1 && " | "} */}
                                    {item?.businessProductCat[idx+1] != undefined && idx < 2 && " | "}
                                  </p>
                                ))}
                              </div>

                              <p className="serchrelusubtparatxtmm">
                                {item?.aboutBusiness?.length > 165
                                  ? item?.aboutBusiness.substring(0, 165) + "..."
                                  : item?.aboutBusiness}
                              </p>

                              {isMobile && (
                                <div className="search-result-view" style={{ display: "flex" }}>
                                  <button
                                    onClick={(e) => handleMobilePageView(e, item)}
                                    style={{ margin: "0.5em 1em 0.5em 0" }}
                                  >
                                    View page
                                  </button>
                                  {item?.memberStatus && (
                                    <button
                                      onClick={(e) => handleMobileProfileView(e, item)}
                                      style={{ margin: "0.5em 0" }}
                                    >
                                      View profile
                                    </button>
                                  )}
                                </div>
                              )}
                            </div>

                          </div>

                        ))}
                        <LoadMoreButton onLoadMore={loadMore} loading={showLoader} hasMore={hasMore} />
                      </div>
                    )}
                  </>
                )}
              </div>

              <BusinessOverview singleData={singleData} />
            </div>
          </div>
        </div>
      </section>
      {ownpagesearchkeay && (
        <AdvancedSearchBox closemodal={setownpagesearchkeay} text={text} initialData={filterKey} result={handleSearchResult} searchFilter={setFilterKey} />
      )}
    </>
  );
};

export default Blmemberlist;